import React from "react";
import VerifiedIcon from "@mui/icons-material/Verified";
import StarIcon from "@mui/icons-material/Star";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import CallMadeIcon from "@mui/icons-material/CallMade";
import VideocamIcon from "@mui/icons-material/Videocam";
import HomeIcon from "@mui/icons-material/Home";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import { Link } from "react-router-dom"; //Link

import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import DomainAddOutlinedIcon from '@mui/icons-material/DomainAddOutlined';

import doctorImg from "../assets/images/doctor.png";

export default function Doctors({ doctor }) {
  // Generate slug from name if doctor_slug not available from API
  const generateSlug = (name) => {
    if (!name) return '';
    return name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  };
  const doctorLink = doctor.doctor_slug || generateSlug(doctor.doctor_name) || doctor.doctor_id;
  const specialityText = doctor.specializations?.map(s => s.specialization_name).join(', ') || "Medical Consultant";
  const hasVideo = doctor.consultation_types?.some(c => c.consultation_type_name.toLowerCase().includes('video'));
  const hasHome = doctor.consultation_types?.some(c => c.consultation_type_name.toLowerCase().includes('home'));
  const hasClinic = doctor.consultation_types?.some(c => c.consultation_type_name.toLowerCase().includes('clinic') || c.consultation_type_name.toLowerCase().includes('hospital') || c.consultation_type_name.toLowerCase().includes('in-clinic'));

  return (
    <div className="dr_box_main_pg">
     <Link to={`/doctordetail/${doctorLink}`}>
    <div className="doctor-card doctor-list-card">
      <div className="dr_consult_page_crt">
          <div className="doctor-image">
            <img 
              src={doctor.doctor_profile_image || doctorImg} 
              alt={doctor.doctor_name}
              onError={(e) => { e.target.onerror = null; e.target.src = doctorImg; }}
            />
            {String(doctor.doctor_is_verified) === "1" && (
              <span> <VerifiedIcon /></span>
            )}
          </div>

         <div className="doctor-info">
          <h3>{doctor.doctor_name}</h3>

          <div className="doc_speciality">
            <p>{specialityText}</p>

            <span>
              <LocalHospitalIcon />
              {doctor.doctor_experience || "0+"} years experience
            </span>
          </div>

          <div className="qualification">
            <label>{doctor.doctor_qualification || "MBBS"}</label>
          </div>

        
         </div>
      </div> 
       <div className="doctor-meta">
           <div className="doctor-tags">
              <span><VideocamIcon /> Online</span>
              <span><HomeIcon /> At Home</span>
              <span><LocationCityIcon /> At Clinic</span>
            </div>
            <div className="only_in_mobile_crt_icon type-consult">
              <span style={{ opacity: hasVideo ? 1 : 0.2, marginRight: '8px' }} title="Video Consultation"><VideocamOutlinedIcon /></span>
              <span style={{ opacity: hasHome ? 1 : 0.2, marginRight: '8px' }} title="Home Visit"><HomeOutlinedIcon /></span>
              <span style={{ opacity: hasClinic ? 1 : 0.2 }} title="In-Clinic"><DomainAddOutlinedIcon /></span>
            </div>

          <button className="doctor-btn">
            <Link to={`/doctordetail/${doctorLink}`}>Book Appointment </Link>{" "}
          </button>
        </div>
    </div>
    </Link>
    </div>
  );
}
